import React from "react";
import "./App.css";
import "./i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import InstallAppPrompt from "./components/InstallAppPrompt";
import { AuthProvider } from "./contexts/AuthContext";
import { CurrencyProvider } from "./contexts/CurrencyContext";
import { Protected } from "./components/Protected";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Marketplace from "./pages/Marketplace";
import ProjectDetail from "./pages/ProjectDetail";
import Wallet from "./pages/Wallet";
import Portfolio from "./pages/Portfolio";
import KYC from "./pages/KYC";
import Admin from "./pages/Admin";
import Mitigate from "./pages/Mitigate";
import VerifyCertificate from "./pages/VerifyCertificate";
import Compliance from "./pages/Compliance";
import PriceAlerts from "./pages/PriceAlerts";
import Methodology from "./pages/Methodology";
import Insights from "./pages/Insights";
import InsightArticle from "./pages/InsightArticle";
import AdminDesk from "./pages/AdminDesk";
import AdminDashboard from "./pages/AdminDashboard";
import AdminBulk from "./pages/AdminBulk";
import Registry from "./pages/Registry";
import Demo from "./pages/Demo";
import Pitch from "./pages/Pitch";
import Producer from "./pages/Producer";
import AdminProducers from "./pages/AdminProducers";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CurrencyProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors />
            <InstallAppPrompt />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/marketplace" element={<Marketplace />} />
              <Route path="/registry" element={<Registry />} />
              <Route path="/demo" element={<Demo />} />
              <Route path="/pitch" element={<Pitch />} />
              <Route path="/methodology" element={<Methodology />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<InsightArticle />} />
              <Route path="/project/:id" element={<ProjectDetail />} />
              <Route path="/wallet" element={<Protected><Wallet /></Protected>} />
              <Route path="/portfolio" element={<Protected><Portfolio /></Protected>} />
              <Route path="/alerts" element={<Protected><PriceAlerts /></Protected>} />
              <Route path="/kyc" element={<Protected><KYC /></Protected>} />
              <Route path="/mitigate" element={<Protected><Mitigate /></Protected>} />
              <Route path="/verify/:id" element={<VerifyCertificate />} />
              <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
              <Route path="/admin/desk" element={<Protected adminOnly><AdminDesk /></Protected>} />
              <Route path="/admin/dashboard" element={<Protected adminOnly><AdminDashboard /></Protected>} />
              <Route path="/admin/bulk" element={<Protected adminOnly><AdminBulk /></Protected>} />
              <Route path="/admin/producers" element={<Protected adminOnly><AdminProducers /></Protected>} />
              <Route path="/producer" element={<Protected><Producer /></Protected>} />
              <Route path="/compliance" element={<Protected adminOnly><Compliance /></Protected>} />
            </Routes>
          </BrowserRouter>
        </CurrencyProvider>
      </AuthProvider>
    </div>
  );
}
